import {Box, Card, Divider, Typography} from '@material-ui/core';
import React from 'react';
import {IFarmInputInvoice, ISupplierUserProfile} from 'constants/interfaces';
import {Skeleton} from '@material-ui/lab';
import moment from 'moment';
import {_NumberWithSpaces} from 'constants/index';

export function InvoiceDetailCard(props: {
  invoice?: IFarmInputInvoice;
  user: ISupplierUserProfile;
  isLoading?: boolean;
}) {
  if (props.isLoading)
    return <Skeleton variant="rect" height={200} style={{borderRadius: 8}} />;
  if (!props.invoice) return null;
  const {invoice, user} = props;
  const formatDate = (date: Date): string => {
    return moment(date).format('YYYY-MM-DD');
  };
  const invoiceDate = (invoice: IFarmInputInvoice) => {
    return formatDate(new Date(parseInt(invoice.insertedDate)));
  };
  const productTotal = () => {
    if (!props.invoice) return '';
    return props.invoice.orders?.reduce(
      (total, order) => total + order.price * order.quantity,
      0,
    );
  };
  return (
    <Card className="farmer-detail-card" variant="outlined">
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Date</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            {invoiceDate(invoice)}
          </Typography>
        </Box>
      </Box>
      <Divider />
      {user.isAdmin && (
        <>
          <Box className="row">
            <Box className="title-container">
              <Typography variant="subtitle2">Depot</Typography>
            </Box>
            <Box className="value-container">
              <Typography variant="body2" color="textSecondary">
                {invoice?.depot.name}
              </Typography>
            </Box>
          </Box>
          <Divider />
        </>
      )}
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Payment Status</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            {invoice?.isPaid ? 'Paid' : 'Unpaid'}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Delivery Type</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            {invoice?.deliveryType}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Invoice Status</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            {invoice?.currOrderStatus.description}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Num Items</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            {invoice?.orders.length}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Products</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            R {_NumberWithSpaces(productTotal())}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Logistics</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            R {_NumberWithSpaces(invoice?.logisticsCost || 0)}
          </Typography>
        </Box>
      </Box>
      <Divider />
      {invoice?.vatExempt != undefined && (
        <>
          <Box className="row">
            <Box className="title-container">
              <Typography variant="subtitle2">VAT Exempt</Typography>
            </Box>
            <Box className="value-container">
              <Typography variant="body2" color="textSecondary">
                {invoice?.vatExempt ? 'Yes' : 'No'}
              </Typography>
            </Box>
          </Box>
          <Divider />
        </>
      )}
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Total</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            R {_NumberWithSpaces(invoice?.total)}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
}
